import React from "react";
import { Tooltip } from "primereact/tooltip";
import { isDesktop } from "../helpers/screenWidth";

type EllipsisCellProps = {
  children?: React.ReactNode;
  field: string;
  id: number;
};

export const EllipsisCell2: React.FC<EllipsisCellProps> = ({
  children,
  field,
  id,
}) => {
  const tooltipId = `${field}-tooltip-${id}`;
  const showTooltip = typeof window !== "undefined" && isDesktop();

  return (
    <>
      <div
        className="ellipsis-cell"
        data-pr-tooltip-id={showTooltip ? tooltipId : undefined}
      >
        {children}
      </div>
      {showTooltip && (
        <Tooltip
          target={`[data-pr-tooltip-id="${tooltipId}"]`}
          content={children}
          autoHide={false}
          position="top"
          className="p-tooltip-custom"
        />
      )}
    </>
  );
};
